export const maskErrors = {
	['CNJ']: 'O CNJ informado está incorreto.',
	['DATE_BR']: 'A data informada está incorreta.',
	['TIME']: 'Essa não é uma hora válida.',
	['CPF']: 'O CPF informado é um número inválido.',
	['IP']: 'O IP informado é um número inválido.',
	['CNPJ']: 'O CNPJ informado é um número inválido',
	['CPF-CNPJ']: 'O CPF/CNPJ informado é um número inválido',
	['PIS_PASEP']: 'O PIS informado é um número inválido.',
	['PHONE_BR']: 'O telefone ou celular informado é um número inválido.',
	['PERCENTS']: 'A porcentagem informada não é válida.',
	['MaskPercents_v2']: 'A porcentagem informada não é válida.',
	['ONLY_NUMBERS']: 'Esse campo aceita somente números',
	['IPv6']: 'O IPv6 informado é um número inválido.',
	['protocolCGov']: 'O protocolo informado é um número inválido.',
	['DARE']: 'O número informado é inválido.',
	['GRERJ']: 'O número informado é inválido.',
	['AGENCY_ACCOUNT']: 'O número informado é inválido.',
	['AGENCY_DIGIT']: 'O número informado é inválido.',

	// ['required-error']: 'O campo é obrigatório',
	// ['cpf-notValid']: 'O CPF informado é um número inválido',
	// ['cpf-incomplete']: 'O CPF informado está incompleto',
	// ['cpf-valid']: 'O CPF informado está correto',

	// ['cnpj-notValid']: 'O CNPJ informado é um número inválido',
	// ['cnpj-incomplete']: 'O CNPJ informado está incompleto',
	// ['cnpj-valid']: 'O CNPJ informado está correto',

	// ['cnpj-cpf-incomplete']: 'O CPF ou CNPJ informado está incompleto',

	// ['cnpj-incomplete-cpf-notValid']: 'O CNPJ informado está incompleto ou o CPF está errado',

	// ['email-incomplete']: 'O email informado está incompleto',
	['EMAIL']: 'O email informado está incorreto',
	// ['email-valid']: 'O email informado está correto',

	// ['cnj-incomplete']: 'O CNJ informado está incompleto',
	// ['cnj-invalid']: 'O CNJ informado está incorreto',
	// ['cnj-valid']: 'CNJ validado',

	// ['phone-incomplete']: 'O telefone informado está incompleto',
	// ['phone-invalid']: 'O telefone informado está incorreto',
	// ['phone-valid']: 'O telefone informado está correto',

	//['pis-incomplete']: 'O PIS / PASEP informado está incompleto',
	//['pis-invalid']: 'O PIS / PASEP informado está incorreto',
	//['pis-valid']: 'O PIS / PASEP informado está correto.',

	// ['numbers-invalid']: 'O campo deve conter valores numéricos',
	// ['numbers-valid']: 'O campo está correto.',

	// ['cep-incomplete']: 'O CEP está incompleto',
	// ['cep-invalid']: 'O CEP está incorreto',
	// ['cep-valid']: 'O CEP está correto',

	// ['date-valid']: 'A data está correta',
	// ['date-invalid']: 'Essa não é uma data válida',
	// ['date-incomplete']: 'A data está incompleta',
	// ['date-invalid-leap']: 'Esse ano não é um ano bissexto',

	// ['time-incomplete']: 'A hora está incompleta',
	// ['time-valid']: 'A hora está correta',
	// ['time-invalid']: 'Essa não é uma hora válida',

	// ['textarea-incomplete']: 'O campo informado está incompleto',
	// ['textarea-invalid']: 'O Limite de caracteres foi atingido',
	// ['textarea-valid']: 'Limite de caracteres do campo validado',
};
